<template>
  <div class="account_block">
    <div class="left">
      <h3 class="large_blue_label">一般アカウント、従業員アカウントについて。</h3>
      <p class="marker-underline_label">設計事務所の従業員の方も事務所の決済情報で受発注ができるように、「従業員アカウント」という仕組みを採用しています。</p>
      <br>
      <br>
      <p>従業員アカウントで発注した場合は、仮決済の段階で決済権限を持っている管理者（一般アカウントを保有）へ自動で決済依頼が出されます。これを受けた管理者は速やかに仮決済を済ませてください。</p>
      <p>従業員アカウントで受注した場合は、従業員が作業により得た報酬が管理者のアカウントへ入ります。</p>
      <br>
      <p class="small_label">特定の個人が作成できる一般アカウントは一つまでですが、従業員アカウントについては複数アカウントを同時に作成できます。</p>
    </div>
    <div class="right">
      <img class='base_image' src='@/assets/image/pages/information/usages/service_4.png'>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AccountBlock"
  }
</script>

<style lang="scss" scoped>
  .account_block {
    .large_blue_label {
      margin-bottom: 2rem;
    }

    @include double_columns(40%, 35%);

    @media screen and (max-width: 767px) {
      > .right > .base_image {
        margin: 2rem auto 0 auto;
      }
    }
  }
</style>